import { render } from "./BaseDisabledCheckbox.vue?vue&type=template&id=fbd87714&scoped=true"
import script from "./BaseDisabledCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseDisabledCheckbox.vue?vue&type=script&lang=js"

import "./BaseDisabledCheckbox.vue?vue&type=style&index=0&id=fbd87714&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd87714"]])

export default __exports__